// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-new */
import '../styles/main.scss';
import initRegionSwitch from '../../src/js/modules/RegionSwitcher/init';
import initAccordion from '../../src/js/modules/Accordion/init';
import initGaTracking from '../../src/js/utils/gaTracking';
import initForms from '../../src/js/modules/form/init';
import footer from '../../src/components/footer';
import latestArticlesCarousel from '../components/latest-articles';
import navigation from '../../src/components/navigation';
import navigationSub from '../../src/components/navigation-sub';
import siteHeaderSearchBlock from '../../src/components/site-header';
import searchForm from '../../src/components/search-form';
import social from '../components/social';
import NavMenu from '../components/nav-menu';
import initFilters from '../components/filters';

initRegionSwitch();
initAccordion();
footer();
latestArticlesCarousel();
navigation();
navigationSub();
siteHeaderSearchBlock();
searchForm();
social();

new NavMenu();

window.addEventListener('load', () => {
	initFilters();
	initForms();
	initGaTracking();
});

if (module.hot) {
	module.hot.accept();
}
